	jQuery(document).ready(function(){

        // Ancla formulario curso    
        jQuery("#single_course_enroll").attr("id","moreInfo");
        jQuery("#moreInfo").attr("href", "#course-form");
    
        // Replace text for modalidad
        var modalidadLi = jQuery('.single_course_meta_data li:nth-last-child(2)');
        var modalidadEl = modalidadLi.find('span.single_course_meta_data_content');
        if(jQuery('#wrapper').hasClass('presencial')) {
            modalidadEl.html('Presencial');
        } else {
            modalidadEl.html('Presencial y online');
        }

        // Read more button
        jQuery('.portfolio_classic_grid_wrapper').each(function() {
            var hrefCourse = jQuery(this).find('.card_link').attr('href');
            var metaCourse = jQuery(this).find('.card__meta_wrapper');
            jQuery(metaCourse).after('<a href="' + hrefCourse + '" class="link-more">Leer más</a>');
        });

        // Tab dirigido a
        var liTab = jQuery('.course-nav-tab-instructor');
        var tabContent = jQuery('.course-tab-panel#dirigido-a').find('p');
        
        if(tabContent.length == 0) {
            liTab.remove();
        }

        jQuery("img").attr("data-defer", "");
    
        jQuery(".section-item-link").on("click", function(e) {
            e.preventDefault();
        })
    });

    /**
     * Ancla listado cursos.
     */
    var target = window.location.hash;
    if ('' != target) {
        window.location.hash = '';
    }

    jQuery(document).on('click', '.ancla-subcat a', function(e) {
        var href = jQuery(this).attr('href');
        var hash = href.slice(href.indexOf('#'), href.length);

        if (0 == jQuery(hash).length) {
            window.location.href = href;

            return;
        }

        e.preventDefault();
        scrollToAnchor(hash);
    });
    
    /**
     * Scroll to anchor.
     */
    function scrollToAnchor(id) {
        var jQueryheader         = jQuery('header');
        var scrollOffset    = jQuery(id).offset();
        var scrollOffsetTop = scrollOffset.top - jQueryheader.outerHeight() - 120;
        jQuery('html, body').animate({
            scrollTop: scrollOffsetTop
        }, 1000);
    }

document.addEventListener(
    "wpcf7mailsent",
    function(event) {
        gtag("event", "generate_lead", {
            event_category: "contacto",
            event_label: "formulario_contacto"
        });
    },
    false
);

var swTools = new swTools('/sw.min.js', {
    cache: {
        enabled: true,
        maxItems: 40,
        noCacheItems: [
        ],
        noCachePatterns: [
            /^(\/){1}4learning-gestion(.*)$/,
            /^(\/){1}wp-admin(.*)$/,
            /^(\/){1}wp-login.php$/
        ]
    },
    prefetch: {
        enabled: true,
        items: [
            'offline'
        ]
    },
    saveDataItems: [
        'fonts.googleapis.com'
    ],
    offline: {
        page: 'offline',
        image: '<svg role="img" aria-labelledby="offline-title"'
            + ' viewBox="0 0 400 300" xmlns="http://www.w3.org/2000/svg">'
            + '<title id="offline-title">Offline</title>'
            + '<g fill="none" fill-rule="evenodd"><path fill="#D8D8D8" d="M0 0h400v300H0z"/>'
            + '<text fill="#9B9B9B" font-family="Times New Roman,Times,serif" font-size="72" font-weight="bold">'
            + '<tspan x="93" y="172">offline</tspan></text></g></svg>'
    },
    defer: {
        images: {
            color: '#FFFFFF'
        },
        youtube: {
            enabled: true
        }
    },
    analytics: {
        enabled: false,
        maxTime: 24 * 60 * 60 * 1000
    }
});